/**
 * The dotboard drawer and the My status modal are mounted once in AppShell
 * (SimpleInOutOverlays) and opened with these window events, like
 * `chat:open-conversation`. Openers live in menus that close on click, so the
 * overlays must never be children of the control that opens them.
 */
export const SIMPLE_INOUT_OPEN_DOTBOARD_EVENT = 'simple-inout:open-dotboard';
export const SIMPLE_INOUT_OPEN_STATUS_EVENT = 'simple-inout:open-status';

export function openSimpleInOutDotboard(): void {
  window.dispatchEvent(new CustomEvent(SIMPLE_INOUT_OPEN_DOTBOARD_EVENT));
}

export function openSimpleInOutStatus(): void {
  window.dispatchEvent(new CustomEvent(SIMPLE_INOUT_OPEN_STATUS_EVENT));
}
